// TODO: Remove from `core-js@4`
require('../modules/es.promise.any');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/esnext.promise.any.js